function useIsSncfUrl(): boolean {
  // TODO: Handle checking URL in SSR.
  if (typeof window === 'undefined') return false;

  return window.location.hostname.includes('sncf');
}

export default useIsSncfUrl;
